const resolveServiceWorkerCandidates = () => {
  if (typeof window === "undefined") {
    return ["/service-worker.js"];
  }

  const candidates = new Set();

  // Ensure the root service worker is always attempted.
  candidates.add("/service-worker.js");

  try {
    const relativeFromLocation = new URL("service-worker.js", window.location.href).pathname;
    if (relativeFromLocation) {
      candidates.add(relativeFromLocation);
    }
  } catch (error) {
    console.warn("Unable to resolve service worker URL from location", error);
  }

  const rawPublicUrl = process.env.PUBLIC_URL;
  if (rawPublicUrl) {
    try {
      const resolvedPublicUrl = new URL(rawPublicUrl, window.location.href);

      if (resolvedPublicUrl.origin === window.location.origin) {
        const normalizedPath = resolvedPublicUrl.pathname.replace(/\/$/, "");
        if (normalizedPath && normalizedPath !== "/") {
          const normalizedBase = normalizedPath.startsWith("/")
            ? normalizedPath
            : `/${normalizedPath}`;
          const scopedUrl = `${normalizedBase}/service-worker.js`;
          candidates.add(scopedUrl.replace(/\/{2,}/g, "/"));
        }
      }
    } catch (error) {
      console.warn("Unable to resolve service worker URL from PUBLIC_URL", error);
    }
  }

  return Array.from(candidates);
};

const registerWithFallback = async () => {
  const candidates = resolveServiceWorkerCandidates();
  let lastError = null;

  for (const candidate of candidates) {
    try {
      const registration = await navigator.serviceWorker.register(candidate);
      if (candidate !== "/service-worker.js") {
        console.info(`Service worker registered using fallback URL: ${candidate}`);
      }
      return registration;
    } catch (error) {
      lastError = error;
      console.warn(`Service worker registration failed for ${candidate}`, error);
    }
  }

  if (lastError) {
    throw lastError;
  }

  return null;
};

export function registerServiceWorker() {
  const shouldRegister =
    process.env.NODE_ENV === "production" &&
    "serviceWorker" in navigator &&
    process.env.REACT_APP_DISABLE_SW !== "true";

  if (shouldRegister) {
    window.addEventListener("load", () => {
      registerWithFallback()
        .then((registration) => {
          if (!registration) return;

          if (registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
          }

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;

            installingWorker.onstatechange = () => {
              if (installingWorker.state === "installed" && navigator.serviceWorker.controller) {
                console.info("OmnioFarm PWA update is ready. Reload to apply changes.");
              }
            };
          };
        })
        .catch((error) => {
          console.error("Service worker registration failed:", error);
        });
    });
  } else {
    unregisterServiceWorker();
  }
}

export function unregisterServiceWorker() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  }
}
